export default __webpack_public_path__ + "static/media/DPE_D.333ac703.png";